import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLiveIndicator = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 9,
	height: 8,
	viewBox: "0 0 9 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 4.5,
		cy: 4,
		r: 2,
		fill: "#c0020d"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 4.5,
		cy: 4,
		r: 3.5,
		stroke: "#c0020d"
	})]
});
export default SvgLiveIndicator;
